import { z } from 'zod'
import { Normalization } from '~/utils/normalization'
import { unboundedValueCodec } from '~/utils/unboundedValueCodec'

const wireCodec = unboundedValueCodec('Infinity')

export const unboundedWire = (value: unknown): unknown => {
  const domain = Normalization.unbounded(value)
  if (typeof domain === 'number') {
    const encoded = z.safeEncode(wireCodec, domain)
    return encoded.success ? encoded.data : domain
  }
  return domain
}
